"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGameVendorSettingsProvider = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const redux_injectors_1 = require("../../utils/@reduxjs/redux-injectors");
const slice_1 = require("./slice");
const saga_1 = require("./saga");
const useGameVendorSettingsProvider = () => {
    (0, redux_injectors_1.useInjectReducer)({ key: slice_1.sliceKey, reducer: slice_1.reducer });
    (0, redux_injectors_1.useInjectSaga)({ key: slice_1.sliceKey, saga: saga_1.gameVendorSettingsProviderSaga });
    const dispatch = (0, react_redux_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        dispatch(slice_1.gameVendorSettingsProviderActions.fetchGameVendorSettings());
    }, [dispatch]);
    return { actions: slice_1.sliceKey };
};
exports.useGameVendorSettingsProvider = useGameVendorSettingsProvider;
//# sourceMappingURL=useGameVendorSettingsProvider.js.map